// Shared shell for the public Terms and Privacy placeholder pages (Story #6712,
// UX-003 / decision D5). The legal wording itself comes from Rob or counsel;
// until then each page says so plainly and gives a contact address.
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { TALK_TO_US_EMAIL } from '../../constants/offer'

export default function LegalPage({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="min-h-screen flex items-start justify-center px-4 py-10 bg-gradient-to-br from-sky-50 via-white to-[#E8EFF4]">
      <div className="w-full max-w-2xl bg-white rounded-2xl border border-[rgba(12,74,110,0.12)] p-8 shadow-xl">
        <h1 className="text-2xl font-bold text-iflow-900">{title}</h1>
        <div role="note" className="mt-4 rounded-lg bg-amber-50 border border-amber-200 p-3 text-sm text-amber-900">
          This page is a placeholder. The full wording is being finalised and will be published here before general
          release.
        </div>
        {children}
        <p className="mt-6 text-sm text-slate-700">
          Questions about this {title.toLowerCase()} in the meantime? Email{' '}
          <a className="text-iflow-600 font-medium hover:text-iflow-700" href={`mailto:${TALK_TO_US_EMAIL}`}>
            {TALK_TO_US_EMAIL}
          </a>
          .
        </p>
        <p className="mt-6 text-sm">
          <Link to="/signup" className="text-iflow-600 font-medium hover:text-iflow-700">&larr; Back to create account</Link>
          <span className="text-slate-400"> · </span>
          <Link to="/welcome" className="text-iflow-600 font-medium hover:text-iflow-700">Welcome</Link>
        </p>
      </div>
    </div>
  )
}
